import styled from "styled-components";
import { Header } from 'features/shared/ui/Page';

export const HeaderPriorityProjects = styled(Header)`
  font-size: 24px;
  font-weight: 600;
  color: #9965F4;
  padding-left: 0;
`;

export const Plate = styled.div`
  border-radius: 20px;
  background: #fff;
  display: flex;
  padding: 24px;
  flex-direction: column;
  gap: 24px;
`;

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;